import axios from '@/config/axios.config';
import { creatUrlParams } from '@/utils/url';
import {mapGetters} from 'vuex'

let devApi = {
  getAccess: '/api/v1/auth/getAccess',
  getToken: '/api/v1/auth/authentication/api',
  commonPhases: '/api/v1/invoke/phases',
}

const devToolMixin = {
  computed: {
    ...mapGetters(['userinfo'])
  },
  methods: {
    getDevBase(url, token) {
      let {
        clientId,
        clientSecret,
        devName,
        devPass
      } = this.userinfo;
      url = window.location.origin + url
      let params = {
        "accessKey": clientId,
        "password": window.atob(devPass).substring(4),
        "secret": clientSecret,
        "url": url,
        "username": devName
      };
      return axios.devPost(devApi.getAccess, {}, params, {
        'Authorization': token
      });
    },
    getToken() {
      let {
        clientId,
        clientSecret,
        devName,
        devPass
      } = this.userinfo;
      let params = {
        "password": window.atob(devPass).substring(4),
        "username": devName
      };
      return axios.devPost(devApi.getToken, {}, params, {
        'Authorization': 'Basic ' + btoa(clientId + ':' + clientSecret)
      });
    },
    async sendDevRequest(url = devApi.commonPhases, params = {}, reqWay = 'GET') {
      let oriUrl = url;
      url = creatUrlParams(url, params)
      // let apiToken = this.$cookie.get("apiToken") || '';
      // if (!apiToken) {
      //   let tokenRes = await this.getToken();
      //   apiToken = tokenRes.token_type + ' ' + tokenRes.access_token;
      //   this.$cookie.set(
      //     "apiToken",
      //     apiToken,
      //     { expires: '1800s' }
      //   );
      // }
      let tokenRes = await this.getToken();
      let apiToken = tokenRes.token_type + ' ' + tokenRes.access_token;
      let res = await this.getDevBase(url, apiToken)
      if (reqWay === 'POST') {
        return axios.devPost(oriUrl, {}, params, {
          ...res,
          'Authorization': apiToken
        });
      }
      return axios.devGet(url, {}, {
        ...res,
        'Authorization': apiToken
      });
    }
  },
}

export default devToolMixin;



// WEBPACK FOOTER //
// ./src/pages/front/document/mixins/devToolMixin.js